import React,{useEffect} from 'react';
export const Comp_Workshop_Detail=(props)=>{
useEffect(()=>{
//alert(JSON.stringify(props.workshop_det));
},[props.workshop_det])

return(<div class="card">
    <div class="card-header bg-cyan">
      <h5 class="card-title">Workshop Details</h5>

      <div class="card-tools">
        <button type="button" class="btn btn-tool" data-card-widget="collapse">
          <i class="fa fa-minus"></i>
        </button>
        {/* <div class="btn-group">
          <button type="button" class="btn btn-tool dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-wrench"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right" role="menu">
            <a href="#" class="dropdown-item">Action</a>
            <a href="#" class="dropdown-item">Another action</a>
            <a href="#" class="dropdown-item">Something else here</a>
            <a class="dropdown-divider"></a>
            <a href="#" class="dropdown-item">Separated link</a>
          </div>
        </div> */}
        <button type="button" class="btn btn-tool" data-card-widget="remove">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    
    <div class="card-body">
    {/* <!-- Info boxes --> */}
        <div class="row">
          <div class="col-12">
            {props.workshop_det.length>0?
            <table class={"table"}>
                <tr>
                <td>Enrollment Date: <b>{props.workshop_det[0]["fmt_machine_ent_date"]}</b></td>
                    <td>Workshop Id: <b>{props.workshop_det[0]["dealer_code"]}</b></td>
                    <td>Workshop Name: <b>{props.workshop_det[0]["business_name"]}</b> </td>
                    
                </tr>
                <tr>
                    <td>Contact Person: <b>{props.workshop_det[0]["person_name"]}</b></td>
                    <td>Mobile No: <b>{props.workshop_det[0]["contact_no"]}</b></td>
                    <td>State/City: <b>{props.workshop_det[0]["state_name"]+" / "+props.workshop_det[0]["city_name"]}</b></td>
                </tr>
                <tr>
                    <td>Last Data Received On: <b>{props.workshop_det[0]["fmt_date_group_v"]}</b></td>
                    <td>Last Location: <b>{props.workshop_gps.length>0?props.workshop_gps[0]["gps_locations"]:''}</b></td>
                    <td></td>
                </tr>
            </table>
            :''}
           
          </div>
        
        </div>
{/* end of quic activity */}

      
    </div>
    
    {/* <div class="card-footer">
      <div class="row">
      </div>
      
    </div> */}
    
  </div>)
}

export default Comp_Workshop_Detail;